module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub-mid-0.189ac55a.svg";